import styled from 'styled-components';
import * as image from './../../../assets/img/cover-page.png';

export const Cover = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100vh;
  min-height: 480px;
  background-repeat: no-repeat;
  background-position: center center;
  background-image: url(${image});
  background-size: cover;
  background-attachment: fixed;
`;
